import { Link } from 'react-router-dom';
import { useT } from '../i18n';
import { AppShell } from '../components/layout';
import { Illustration } from '../components/ui';
import { sceneImage } from '../lib/illustrations';

export const NotFound = () => {
  const t = useT();
  return (
    <AppShell>
      <div className="mx-auto flex max-w-[640px] flex-col items-center py-10 text-center">
        <div aria-hidden="true" className="h-[240px] w-full max-w-[460px]">
          <Illustration src={sceneImage('not-found-kite')} alt="" fit="contain" />
        </div>
        <h1 className="mb-3 mt-6">{t('common.notFound')}</h1>
        <Link
          to="/"
          className="inline-flex min-h-btn items-center rounded-md bg-lagoon-600 px-6 text-label font-extrabold text-white shadow-lagoon hover:bg-lagoon-700"
        >
          {t('common.home')}
        </Link>
      </div>
    </AppShell>
  );
};
